import { buildService, buildFormData } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const getBasePath = function () {
  let isMyScope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return isMyScope ? '/my/how_to_items' : '/how_to_items';
};
const serviceMap = {
  default: buildService(getBasePath(), {
    only: ['all', 'create', 'delete', 'update']
  }, {
    only: ['postFormData', 'putFormData']
  }),
  myScope: buildService(getBasePath(true), {
    only: ['all', 'create', 'delete', 'update']
  }, {
    only: ['postFormData', 'putFormData']
  })
};
const howToItemService = {
  useFetchAllItems: function (setLoading) {
    let isMyScope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const service = isMyScope ? serviceMap.myScope : serviceMap.default;
    const [items, setItems, fetchItems] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        const response = await service.all();
        if (Array.isArray(response)) return response;
        if (response && typeof response === 'object') {
          const key = Object.keys(response).find(k => Array.isArray(response[k]));
          return key ? response[key] : [];
        }
        return [];
      }, []),
      setLoading,
      initialStateValue: []
    });
    return [items, setItems, fetchItems];
  },
  useDeleteItem: function (setLoading, setItems, items) {
    let isMyScope = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const service = isMyScope ? serviceMap.myScope : serviceMap.default;
    const deleteItem = serviceMethods.useDelete({
      callback: useCallback(async itemId => {
        if (isMyScope) return;
        await service.delete(itemId);
        setItems(items.filter(i => i.id !== Number(itemId)));
      }, [items, setItems, isMyScope]),
      setLoading
    });
    return [deleteItem];
  },
  useUpdateItem: function (setLoading, setItems, items) {
    let isMyScope = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const service = isMyScope ? serviceMap.myScope : serviceMap.default;
    const updateItem = serviceMethods.useUpdate({
      callback: useCallback(async _ref => {
        let {
          id,
          data
        } = _ref;
        if (isMyScope) return;
        const formData = buildFormData(data);
        const response = await service.putFormData("".concat(id), formData);
        setItems(items.map(i => i.id === id ? response : i));
        return response;
      }, [items, setItems, isMyScope]),
      setLoading
    });
    return [updateItem];
  },
  useCreateItem: function (setLoading, setItems, items) {
    let isMyScope = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const service = isMyScope ? serviceMap.myScope : serviceMap.default;
    const createItem = serviceMethods.usePostFormData({
      callback: useCallback(async _ref2 => {
        let {
          formData
        } = _ref2;
        if (isMyScope) return;
        const response = await service.postFormData(getBasePath(isMyScope), formData);
        setItems([...items, response]);
        return response;
      }, [items, setItems, isMyScope]),
      setLoading
    });
    return [createItem];
  },
  useReorderItems: function (setLoading, setItems) {
    let isMyScope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const service = isMyScope ? serviceMap.myScope : serviceMap.default;
    const reorderItems = serviceMethods.useHttpCallback({
      callback: useCallback(async orderedItems => {
        if (isMyScope) return;
        const payload = {
          order: orderedItems.map((item, idx) => ({
            id: item.id,
            position: idx + 1
          }))
        };
        await service.update('reorder', payload);
        setItems([...orderedItems]);
      }, [setItems, isMyScope]),
      setLoading
    });
    return [reorderItems];
  }
};
howToItemService.useCrud = function (setLoading) {
  let isMyScope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const [items, setItems, fetchItems] = howToItemService.useFetchAllItems(setLoading, isMyScope);
  const [deleteItem] = howToItemService.useDeleteItem(setLoading, setItems, items, isMyScope);
  const [updateItem] = howToItemService.useUpdateItem(setLoading, setItems, items, isMyScope);
  const [createItem] = howToItemService.useCreateItem(setLoading, setItems, items, isMyScope);
  const [reorderItems] = howToItemService.useReorderItems(setLoading, setItems, isMyScope);
  return {
    items,
    setItems,
    fetchItems,
    deleteItem,
    updateItem,
    createItem,
    reorderItems
  };
};
export default howToItemService;